import styled from "styled-components";

export const HelperAgentAvatar = () => {
  return (
    <Wrap>
      <img
        src="/helper_agent.svg"
        alt="Helper Agent Avatar"
        width="22"
        height="22"
      />
    </Wrap>
  )
}

const Wrap = styled.div`
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
